import { Injectable } from '@angular/core';
import { SputnikService } from './sputnik.service';
import { User } from '../model/user';
import { SignInUser } from '../interfaces/sign-in-user';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public user: User;
    public isAuthenticated: boolean;

    constructor(
        protected sputnik: SputnikService
    ) { }

    private async setUserLogin(responseLogin: any): Promise<void> {
        if (responseLogin.success) {
            const reponseUserData = await this.sputnik.getUserCompletedData(responseLogin.user.id);
            this.user = new User({ ...responseLogin.user, completedSteps: reponseUserData.data });
            this.isAuthenticated = true;
        }
    }

    public async login(email: string, password: string): Promise<any> {
        return;
    }

    public async loginFacebook(): Promise<void> {
        // await this.setItemAsync();
    }

    public async loginGoogle(): Promise<void> {
        // await this.setItemAsync();
    }

    public logout(): void {
        sessionStorage.removeItem('token');
    }

}
